import React, { useState, useEffect } from "react";
import {
  MapPin,
  FileText,
  Calendar,
  Send,
  Percent,
  User,
  Anchor,
  Command,
  Layers,
  Clock,
  ZoomIn,
  Share2,
  Briefcase,
  Share,
  ArrowRight,
} from "react-feather";
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Badge,
  Row,
  Col,
  Label,
  Input,
  UncontrolledTooltip,
  FormGroup,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
// import "flatpickr/dist/themes/material_orange.css";
import PostApiCall from "../../Api/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { delay } from "../../Helper/ToastDelay";
import Notiflix from "notiflix";
import Parser from "html-react-parser";
import * as Yup from "yup";
import moment from "moment";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ProfileAction } from "../../Store/Actions/ProfileAction";
import { NotificationAction } from "../../Store/Actions/NotificationAction";
import GetApiCall from "../../Api/GetApi";
import { PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from "../../color";
import { useFormik } from "formik";
import CommonModal from "../../Components/CommonModal";
import InteractiveJobCard from "../../Components/InteractiveJobCard";
import { generateCustomStyles } from "../../Helper/CustomStyleError";
const validationSchema = Yup.object().shape({
  // priceRage: Yup.string().required("Price is required"),
  remarks: Yup.string().required("Remarks is required"),
});
const JobDetail = () => {
  const history = useHistory();
  const [JobsData, setJobsData] = useState();
  const [modalOpen, setModalOpen] = useState(false);

  const loginData = useSelector((state) => state?.login);
  const { user } = useSelector((state) => state?.profile);
  console.log(user, loginData);
  // const [refresh,setRefresh]=useState(false)
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem("user") !== null) {
      dispatch(ProfileAction.GetSeekerDetails());
    }
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    Notiflix.Loading.standard();
    const id = history?.location?.pathname?.split("/")[2];
    if (id) {
      fetchUserDetail(id);
    }
  }, [history?.location]);

  const fetchUserDetail = async (id) => {
    // Notiflix.Loading.standard();
    try {
      const json = await GetApiCall.getRequest(
        `GetJobOpeningById?id=${id}&userid=${loginData?.fld_id || 0}`
      );

      // const json = await PostApiCall.postRequest(`GetJobUserById?${history.location.state.fld_id}`);
      const res = await json.json();

      setJobsData(res.data);

      formik.setFieldValue("purposaldate", res?.data?.fld_auditdate);

      Notiflix.Loading.remove();
    } catch (error) {
      console.log(error);
      toast.error(SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }
    Notiflix.Loading.remove();
  };

  const formik = useFormik({
    initialValues: {
      priceRage: 1,
      remarks: "",
      auditPurposeDate: 1,
      purposaldate: "",
    },
    validateOnChange: true,

    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const payload = {
          recruiterremark: "",
          auditid: JobsData.fld_id,
          userid: user.fld_id[0],
          auditorremark: values.remarks,
          price: values.priceRage,
          auditstatus: "Pending",
          purposaldate: values.auditPurposeDate == 0 ? values.purposaldate : "",
          proposalstatus: values.auditPurposeDate,
        };
       

        const res = await PostApiCall.postRequest(
          payload,
          "AddJobAuditApplicant"
        );

        if (res.status === 200 || res.status === 201) {
          Notiflix.Loading.remove();
          setModalOpen(false);
          Notiflix.Report.success(
            "Applied Successfully!",
            "Your application has been submitted successfully. Team Betel will reach out to you within 3 to 5 business days.",
            "Ok",
            () => {
              history.push("/jobs-opening-list");
            }
          );
        } else {
          toast.error(SomethingWrong, {
            autoClose: delay,
            toastId: 1,
          });

          window.scrollTo(0, 0);
          Notiflix.Loading.remove();
        }
      } catch (error) {
        Notiflix.Loading.remove();
        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      }
    },
  });

  const onApplyButtonClicked = () => {
    if (loginData) {
      if (user.fld_verifyaccount === 1 && user.fld_verifyaccount !== null) {
        setModalOpen(true);
      } else {
        Notiflix.Report.warning(
          "Incomplete Profile",
          "Kindly complete your profile details.",
          "Ok",
          () => {}
        );
      }
    } else {
      history.push("/login");
    }
  };

  const exp = ({ max, min, type }) => {
    let temp = "";
    if (min >= 0 && max) {
      return `${min} - ${max} ${type}`;
    }
    if (min == 0) {
      return `Fresher & Above`;
    }
    if (min) {
      return `${min}+ ${type}`;
    }
  };

  const ExperienceDisplay = ({ color, fontSize, icon, content }) => {
    return (
      <p
        style={{
          display: "flex",
          alignItems: "baseline",
          gap: "2px",
        }}
      >
        {/* <Briefcase size={12} style={{ color }} /> */}
        {icon}
        <span style={{ color, fontSize }}>{content}</span>
      </p>
    );
  };

  const handleShare = (data) => {
    const currentUrl = window.location.href;
    //     const msg = `Field Audit Job Opportunity at Betel Jobs

    //   I came across this job opening for Field Auditor at Betel Jobs (by TRPW Strategic Partners), and I thought it might be a great fit for you or someone in your network who has experience in field audits.

    //   Upcoming Audit in City, State name.

    // Audit Details:
    // 1. Audit ID: ${data?.fld_code || "N/A"}
    // 2. Nature of Audit: ${data?.fld_title || "N/A"}
    // 3. Qualification Required: ${data?.fld_qualification || "N/A"}
    // 4. Experience Required: ${exp({
    //       min: JobsData?.fld_minexperience || 0,
    //       type: JobsData?.fld_experiencetype || "Years",
    //     })}
    // 5. No. of Resources Required: ${JobsData?.fld_positions || "N/A"}
    // 6. Start Date: ${JobsData?.fld_openingdate || "N/A"}
    // 7. Duration of Assignment (Days): ${JobsData?.fld_assignduration || "N/A"}
    // 8. Industry: ${JobsData?.fld_area || "N/A"}
    // 9. Location: ${JobsData?.fld_city || "N/A"}, ${JobsData?.fld_state || "N/A"}
    // 10.Budget Range : ₹ ${JobsData.fld_minsalary} - ₹ ${JobsData.fld_maxsalary} ${
    //       JobsData.fld_salarytype
    //     }
    // 10. Vehicle Required: ${JobsData?.fld_vehicle || "No"}
    // 11. Remote: ${JobsData?.fld_remotework ? "Yes" : "No"}
    // 12. Laptop Required: ${JobsData?.fld_laptop ? "Yes" : "No"}
    // 13. Full Audit Place Address: ${JobsData?.fld_address || "N/A"}

    //   Click here to apply: ${currentUrl}

    //   If this sounds interesting, feel free to apply or share it with someone who might be a good fit. Please connect on support@beteljobs.com or 9319179297 if you'd like more details!`;
    const msg = `Field Audit Job Opportunity at Betel Jobs  

I came across this job opening for a **Field Auditor** at **Betel Jobs** (by TRPW Strategic Partners), and I thought it might be a great fit for you or someone in your network with experience in field audits.  

📍 **Upcoming Audit in**: ${JobsData?.fld_city || "City"}, ${
      JobsData?.fld_state || "State"
    }  

### **Audit Details:**
➡️ **Audit ID**: ${data?.fld_code || "N/A"}  
➡️ **Nature of Audit**: ${data?.fld_title || "N/A"}  
➡️ **Qualification Required**: ${data?.fld_qualification || "N/A"}  
➡️ **Experience Required**: ${exp({
      min: JobsData?.fld_minexperience || 0,
      type: JobsData?.fld_experiencetype || "Years",
    })}  
➡️ **No. of Resources Required**: ${JobsData?.fld_positions || "N/A"}  
➡️ **Start Date**: ${moment(JobsData?.fld_auditdate).format("ll") || "N/A"}  
➡️ **Duration of Assignment**: ${JobsData?.fld_assignduration || "N/A"} days  
➡️ **Industry**: ${JobsData?.fld_area || "N/A"}  
➡️ **Location**: ${JobsData?.fld_city || "N/A"}, ${
      JobsData?.fld_state || "N/A"
    }  
➡️ **Budget Range**: ₹${JobsData.fld_minsalary} - ₹${JobsData.fld_maxsalary} ${
      JobsData.fld_salarytype
    }  
➡️ **Vehicle Required**: ${JobsData?.fld_vehicle || "No"}  
➡️ **Remote Work**: ${JobsData?.fld_remotework ? "Yes" : "No"}  
➡️ **Laptop Required**: ${JobsData?.fld_laptop ? "Yes" : "No"}  
➡️ **Full Audit Location**: ${JobsData?.fld_address || "N/A"}  

🔗 **Click here to apply**: ${currentUrl}  

If this sounds interesting, feel free to apply or share it with someone who might be a good fit.  

📩 **For more details, contact us at:**  
✉️ support@beteljobs.com  
📞 9319179297  
`;
    // if (navigator.share) {
    //   navigator.share({
    //     title: JobsData?.fld_title,
    //     text: msg,
    //     // url: window.location.href,
    //   });
    // }

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(msg)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div
      className="App mt-5 "
      style={{ backgroundColor: "rgb(238 238 244 / 34%)" }}
    >
      <section className="mt-5">
        <div className="container mt-4 " style={{ minHeight: "100vh" }}>
          {JobsData && (
            <Row>
              {/* Job Card */}
              <Col md="8">
                <Card>
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      className="d-flex text-dark justify-content-between align-items-center"
                    >
                      {JobsData?.fld_title}
                      {/* <span className="badge bg-secondary">Audit Firm</span> */}
                    </CardTitle>
                    <CardText>
                      <small className="text-muted">
                        {" "}
                        <span
                          className="px-2 py-1"
                          style={{
                            color: PRIMARY_COLOR,
                            border: "1px solid #c16d18",
                            borderRadius: "50px",
                          }}
                        >
                          {JobsData?.fld_type}
                        </span>
                      </small>
                    </CardText>
                    <Row className="mt-2">
                      <Col md={6} sx={12} lg={4}>
                        <ExperienceDisplay
                          color={PRIMARY_TEXT_COLOR}
                          fontSize={"13px"}
                          content={exp({
                            min: JobsData.fld_minexperience,
                            type: JobsData.fld_experiencetype,
                          })}
                          icon={
                            <Briefcase
                              size={12}
                              style={{ color: PRIMARY_TEXT_COLOR }}
                            />
                          }
                        />
                      </Col>
                      {JobsData.fld_minsalary !== 0 &&
                      JobsData.fld_maxsalary ? (
                        <Col md={6} sx={12} lg={4}>
                          <ExperienceDisplay
                            color={PRIMARY_TEXT_COLOR}
                            fontSize={"13px"}
                            content={
                              <>
                                ₹ {JobsData.fld_minsalary} -{" "}
                                {JobsData.fld_maxsalary} &nbsp;
                                {JobsData.fld_salarytype}
                              </>
                            }
                          />
                        </Col>
                      ) : (
                        <Col md={6} sx={12} lg={4}>
                          <ExperienceDisplay
                            color={PRIMARY_TEXT_COLOR}
                            fontSize={"13px"}
                            content={<span>₹ Not Disclosed</span>}
                          />
                        </Col>
                      )}
                      <Col md={6} sx={12} lg={4}>
                        <ExperienceDisplay
                          color={PRIMARY_TEXT_COLOR}
                          fontSize={"13px"}
                          content={
                            <span>
                              {JobsData?.fld_state} ,&nbsp;{JobsData?.fld_city}
                            </span>
                          }
                          icon={
                            <MapPin
                              size={11}
                              style={{ color: PRIMARY_TEXT_COLOR }}
                            />
                          }
                        />
                      </Col>
                    </Row>
                    <hr />
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                      <div>
                        <small style={{ color: PRIMARY_TEXT_COLOR }}>
                          <span style={{ color: "black" }}>
                            {" "}
                            Apply before :
                          </span>{" "}
                          {moment(
                            JobsData?.fld_closingdate,
                            "YYYY-MM-DD"
                          ).format("MMM DD, YYYY")}{" "}
                          &nbsp; | &nbsp;
                        </small>
                        {/* <small style={{ color: PRIMARY_TEXT_COLOR }}>
                          <span style={{ color: "black" }}> Posted:</span>{" "}
                          {moment(
                            JobsData?.fld_openingdate,
                            "YYYY-MM-DD"
                          ).format("MMM DD, YYYY")}{" "}
                          &nbsp; | &nbsp;
                        </small> */}
                        <small style={{ color: PRIMARY_TEXT_COLOR }}>
                          <span style={{ color: "black" }}>Openings:</span>{" "}
                          {JobsData.fld_positions} &nbsp; | &nbsp;
                          <span style={{ color: "black" }}> Applicants: </span>
                          {/* Less than 10 */}
                          {JobsData?.fld_totalapplied}
                        </small>
                      </div>
                      <div>
                        <Button
                          color="light"
                          className="btn-icon p-2 mr-2"
                          onClick={() => handleShare(JobsData)}
                          id="shareBtn"
                        >
                          <Share2 size={18} className="text-muted" />
                        </Button>
                        <UncontrolledTooltip target="shareBtn">
                          Share job
                        </UncontrolledTooltip>
                        {/* <Button
                          className="mr-2 btnsborder"
                          onClick={handleShare}
                        >
                          {" "}
                          <Share2 size={15} /> Share
                        </Button> */}
                        <>
                          {(user?.fld_isadmin != 1 ||
                            user?.fld_usertype !== "Staff") && (
                            <>
                              {JobsData?.fld_candidateid !== null ? (
                                <span className="GreenWhite py-2 px-2 mt-2">
                                  Applied
                                </span>
                              ) : (
                                <Button
                                  className="btns"
                                  style={{ textTransform: "capitalize" }}
                                  disabled={user?.fld_isadmin === 1}
                                  // onClick={()=>setModalOpen(true)}
                                  onClick={onApplyButtonClicked}
                                >
                                  Apply
                                </Button>
                              )}
                            </>
                          )}
                        </>
                      </div>
                    </div>
                  </CardBody>
                </Card>

                {/* Job Description */}
                <Card className="my-3">
                  <CardBody>
                    <h6 style={{ color: "black" }}>Audit Description</h6>
                    <CardText
                      className=""
                      style={{ color: PRIMARY_TEXT_COLOR, fontSize: "12px" }}
                    >
                      {JobsData.fld_jobdescription !== undefined
                        ? Parser(
                            JobsData.fld_jobdescription
                              .replace(/font-family/g, "")
                              .replace(/<p>/g, "")
                              .replace(/\s+/g, " ") // Replace multiple spaces with a single space
                              .trim() // Trim leading and trailing whitespace
                          )
                        : ""}
                    </CardText>
                    <h6 style={{ color: "black" }} className="my-2">
                      Audit Highlights
                    </h6>
                    <CardText
                      style={{ color: PRIMARY_TEXT_COLOR, fontSize: "12px" }}
                    >
                      {JobsData?.fld_auditdate && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ color: "black" }}>Audit Dates:</span>
                          <span>
                            {moment(JobsData.fld_auditdate).format("ll")}
                            {JobsData.fld_auditenddate && (
                              <span>
                                {" "}
                                -{" "}
                                {moment(JobsData.fld_auditenddate).format("ll")}
                              </span>
                            )}
                          </span>
                        </div>
                      )}

                      {JobsData?.fld_category && (
                        <div>
                          <span style={{ color: "black" }}>Industry Type</span>{" "}
                          : {JobsData.fld_category}
                        </div>
                      )}
                      {JobsData?.fld_assignduration && (
                        <div>
                          <span style={{ color: "black" }}>
                            Duration of Assignment
                          </span>{" "}
                          : {JobsData.fld_assignduration}
                        </div>
                      )}
                      {JobsData?.fld_qualification && (
                        <div>
                          <span style={{ color: "black" }}>
                            Minimum Qualification
                          </span>{" "}
                          : {JobsData.fld_qualification}
                        </div>
                      )}
                      {JobsData?.fld_address && (
                        <div>
                          <span style={{ color: "black" }}>Location</span> :{" "}
                          {JobsData.fld_address}
                        </div>
                      )}
                      {JobsData?.fld_area && (
                        <div>
                          <span style={{ color: "black" }}>Area</span> :{" "}
                          {JobsData.fld_area}
                        </div>
                      )}
                      {JobsData?.fld_remotework && (
                        <div>
                          <span style={{ color: "black" }}>Remote</span> :{" "}
                          {JobsData.fld_remotework}
                        </div>
                      )}
                      {JobsData?.fld_vehicle && (
                        <div>
                          <span style={{ color: "black" }}>
                            Vehicle Requirement
                          </span>{" "}
                          : {JobsData.fld_vehicle}
                        </div>
                      )}
                      {JobsData?.fld_laptop && (
                        <div>
                          <span style={{ color: "black" }}>
                            Laptop Requirement
                          </span>{" "}
                          : {JobsData.fld_laptop}
                        </div>
                      )}
                    </CardText>
                  </CardBody>
                </Card>
                <Card className="my-3">
                  <CardBody>
                    <h6 style={{ color: "black" }}>General Terms</h6>
                    <CardText
                      className="mt-3"
                      style={{ color: PRIMARY_TEXT_COLOR, fontSize: "12px" }}
                    >
                      {JobsData.fld_skillset != undefined
                        ? Parser(
                            JobsData.fld_skillset
                              .replace(/font-family/g, "")
                              .replace(/<p>/g, "")
                          )
                        : ""}
                    </CardText>
                    {/* 
                  <CardTitle tag="h6" className="mt-4">
                    Key Skills
                  </CardTitle>
                  <div className="d-flex gap-2 flex-wrap">
                    <Badge color="light" className="border">
                      Statutory Audit
                    </Badge>
                    <Badge color="light" className="border">
                      Internal Audit
                    </Badge>
                    <Badge color="light" className="border">
                      Tax Audit
                    </Badge>
                    <Badge color="light" className="border">
                      English
                    </Badge>
                  </div>
                  <div className="mt-4 d-flex gap-2">
                    <i className="bi bi-facebook"></i>
                    <i className="bi bi-linkedin"></i>
                    <i className="bi bi-whatsapp"></i>
                  </div> */}
                  </CardBody>
                </Card>
              </Col>

              {/* Sidebar */}
              <Col md="4">
                <Card>
                  <CardBody>
                    <CardTitle tag="h5" style={{ color: PRIMARY_TEXT_COLOR }}>
                      Referral Program
                    </CardTitle>

                    <p style={{ color: PRIMARY_TEXT_COLOR }}>
                      Help your friends join and grow with you
                    </p>
                    <Button
                      onClick={() => history.push("/refer-earn")}
                      style={{
                        backgroundColor: PRIMARY_COLOR,
                        border: "none",
                        textTransform: "capitalize",
                      }}
                      className="d-inline-flex align-items-center px-4 py-2 mt-2"
                    >
                      Know More
                      <ArrowRight size={20} className="ms-2" />
                    </Button>
                  </CardBody>
                </Card>
                {JobsData &&
                  JSON.parse(JobsData?.similarJob).map((ele) => (
                    <InteractiveJobCard JobsData={ele} />
                  ))}
              </Col>
            </Row>
          )}
        </div>
      </section>
      {modalOpen === true && (
        <CommonModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          heading={"Audit Details"}
          contentBody={
            <div style={{ marginTop: "0px", zIndex: "50" }}>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                {JobsData?.fld_auditenddatetype !== "Yes" && (
                  <>
                    <Row className="my-3">
                      <Col sm="6">
                        <Label htmlFor="nameVertical">
                          Audit proposed date accepted{" "}
                          <span className="mandatory">*</span>
                        </Label>
                        {formik.touched.auditPurposeDate &&
                          formik.errors.auditPurposeDate && (
                            <div className="error text-danger text-right">
                              {formik.errors.auditPurposeDate}
                            </div>
                          )}
                      </Col>
                      <Col sm="6">
                        <div className="d-flex justify-content-around">
                          <div>
                            <Input
                              type="radio"
                              name="auditPurposeDate"
                              onChange={() => {
                                formik.setFieldValue("auditPurposeDate", 1);
                              }}
                              style={{ accentColor: "#c16d18" }}
                              checked={formik.values.auditPurposeDate == 1}
                              disabled={JobsData?.fld_auditenddatetype == "Yes"}
                            />
                            <span>Yes</span>
                          </div>

                          <div className="">
                            {" "}
                            <Input
                              type="radio"
                              name="auditPurposeDate"
                              onChange={() => {
                                formik.setFieldValue("auditPurposeDate", 0);
                                // setStatusAudit(1)
                              }}
                              style={{ accentColor: "#c16d18" }}
                              checked={formik.values.auditPurposeDate == 0}
                              disabled={JobsData?.fld_auditenddatetype == "Yes"}
                            />
                            <span>No</span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {formik.values.auditPurposeDate == 0 && (
                      <Row className="my-3">
                        <Col sm="6">
                          <Label htmlFor="nameVertical" className="mt-2">
                            Select Proposed Date
                            <span className="mandatory">*</span>
                          </Label>
                        </Col>

                        <Col sm="6">
                          <FormGroup>
                            <Flatpickr
                              value={formik.values.purposaldate}
                              className={`form-control ${
                                formik.values.auditPurposeDate === 1
                                  ? "disabled-input"
                                  : ""
                              }`}
                              placeholder="DD-MM-YYYY"
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                                minDate: JobsData?.fld_auditdate,
                                maxDate: JobsData?.fld_auditenddate,
                                // disable: formik.values.auditPurposeDate === 1 ? [""] : [], // Disables selection
                              }}
                              styles={generateCustomStyles(
                                "purposaldate",
                                formik
                              )}
                              name="purposaldate"
                              onBlur={formik.handleBlur}
                              onChange={(dates) => {
                                if (dates?.[0]) {
                                  const formattedDate = moment(dates[0]).format(
                                    "YYYY-MM-DD"
                                  );
                                  formik.setFieldValue(
                                    "purposaldate",
                                    formattedDate
                                  );
                                } else {
                                  formik.setFieldValue("purposaldate", ""); // Handle case when date is cleared
                                }
                              }}
                            />
                            {formik.touched.purposaldate &&
                              formik.errors.purposaldate && (
                                <div className="error text-danger text-right">
                                  {formik.errors.purposaldate}
                                </div>
                              )}
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                  </>
                )}
                <div className="mb-3">
                  <Label htmlFor="exampleText">
                    Auditor Remark<span className="mandatory">*</span>
                  </Label>
                  <Input
                    type="textarea"
                    name="remarks"
                    id="nameVertical"
                    className="rounded-0 p-3"
                    onChange={formik.handleChange}
                    value={formik.values.remarks}
                    aria-rowcount={4}
                    // disabled={jobOpeningDetail?.fld_auditorremark !== null}
                  />
                  {formik.touched.remarks && formik.errors.remarks && (
                    <div className="error text-danger pl-2">
                      {formik.errors.remarks}
                    </div>
                  )}
                </div>
              </form>
            </div>
          }
          onConfirm={() => formik.handleSubmit()}
          confirmText={"Submit"}
          cancelText={"Cancel"}
          onCancel={() => setModalOpen(false)}
        />
      )}
    </div>
  );
};

export default JobDetail;
